export default __webpack_public_path__ + "static/media/hero-bg-d.b1a74254.jpg";